"use client";

import React, { memo } from "react";
import dayjs from "dayjs";
import { cn } from "utils";

export const ReportDate: React.FC<{ created?: number; className?: string }> =
  memo(({ created, className }) => {
    if (!created) {
      return null;
    }
    return (
      <span
        className={cn(
          "body_s text-content_tertiary whitespace-nowrap",
          className,
        )}
      >
        {dayjs(created).format("MMM D HH:mm")}
      </span>
    );
  });

ReportDate.displayName = "ReportDate";
